/**
 * Board b0hx: an organization owner or admin is never a guest. The server
 * clears `organization_memberships.is_guest` whenever the role becomes owner
 * or admin and refuses `isGuest: true` for one; every permission check that
 * reads the flag goes through `isOrgGuest` so a stale row can't lock an
 * owner out either.
 */
export type OrgRole = 'owner' | 'admin' | 'member'

export function isOrgAdminRole(role: string): boolean {
  return role === 'owner' || role === 'admin'
}

/** The guest flag as permissions should read it — never true for owner/admin. */
export function isOrgGuest(membership: { role: string; isGuest: boolean | number }): boolean {
  return !!membership.isGuest && !isOrgAdminRole(membership.role)
}
